"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const DescriptionList_vue_1 = __importDefault(require("./../DescriptionList.vue"));
const overdue_1 = __importDefault(require("../../api/overdue"));
exports.default = (0, vue_1.defineComponent)({
    name: 'CustomerDetail',
    components: {
        DescriptionList: DescriptionList_vue_1.default
    },
    props: {
        id: {
            type: String,
            required: true
        },
        extraData: {
            type: Object,
            required: false
        },
        defaultCollapse: {
            type: Boolean,
            required: false
        },
    },
    data() {
        return {
            detail: null,
            collapse: this.defaultCollapse,
            description: [
                {
                    name: '承租人',
                    prop: 'customerName'
                },
                {
                    name: '联系电话',
                    prop: 'mobile'
                },
                {
                    name: '身份证号',
                    prop: 'certid'
                },
                {
                    name: '配偶',
                    prop: 'spouseName'
                },
                {
                    name: '联系电话',
                    prop: 'spouseMobile'
                },
                {
                    name: '身份证号',
                    prop: 'spouseCertid'
                },
                {
                    name: '有效姓名',
                    prop: 'qtName'
                },
                {
                    name: '联系电话',
                    prop: 'qtTel'
                },
                {
                    name: '身份证号',
                    prop: 'qtCertid'
                },
                {
                    name: '亲属姓名',
                    prop: 'fmName'
                },
                {
                    name: '联系电话',
                    prop: 'fmTel'
                },
                {
                    name: '身份证号',
                    prop: 'fmCertid'
                },
            ]
        };
    },
    watch: {
        id: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.getDetail();
                }
            }
        }
    },
    methods: {
        onCollapseChange(value) {
            this.collapse = value;
        },
        getDetail() {
            if (this.id) {
                overdue_1.default.customerContacts.require({
                    customerid: this.id
                }).then((res) => {
                    const detail = res.data.data || {};
                    this.detail = detail;
                });
            }
        }
    }
});
